<template>
    <!-- Menú Inferior de la Aplicación -->
    <div class="appBottomMenu">
        <!-- active -->
        <a href="/" class="item "> 
            <div class="col">
                <ion-icon name="pie-chart-outline"></ion-icon>
                <strong>Visión General</strong>
            </div>
        </a>
            <a href="#" class="item" data-bs-toggle="modal" data-bs-target="#depositActionSheet">
            <!-- <a href="#" class="item"> -->
                <div class="col">
                    <div class="action-button large">
                        <ion-icon name="add-outline"></ion-icon>
                    </div>
                </div>
            </a>
        <!-- <a href="/pages" class="item">
            <div class="col">
                <ion-icon name="document-text-outline"></ion-icon>
                <strong>Páginas</strong>
            </div>
        </a> -->
        <!-- <a href="app-components.php" class="item">
            <div class="col">
                <ion-icon name="apps-outline"></ion-icon>
                <strong>Componentes</strong>
            </div>
        </a>
        <a href="app-cards.php" class="item">
            <div class="col">
                <ion-icon name="card-outline"></ion-icon>
                <strong>Mis Tarjetas</strong>
            </div>
        </a> -->
        <a href="/settings" class="item">
            <div class="col">
                <ion-icon name="settings-outline"></ion-icon>
                <strong>Configuración</strong>
            </div>
        </a>
    </div>
    <!-- * Menú Inferior de la Aplicación -->
</template>